
import React, { Fragment } from 'react'
import { Route } from 'react-router-dom';
import { LeafCollectionSummaryFINReportWithOutVehicel } from './Pages';

export const LeafCollectionSummaryFINReportWithOutVehicelRoute = ({ match }) => (
    <Fragment>
        <Route exact path={`${match.path}`} component={LeafCollectionSummaryFINReportWithOutVehicel} />
    </Fragment>
)